import { Component, Input, OnInit } from "@angular/core";
import * as _ from "lodash";
import { User } from "src/app/domain/user";
import { UserService } from "src/app/user.service";

@Component({
  selector: "app-chip-select-inspector",
  templateUrl: "./chip-select-inspector.component.html",
  styleUrls: ["./chip-select-inspector.component.scss"],
})
export class ChipSelectInspectorComponent implements OnInit {
  @Input()
  name: string;

  @Input()
  inspectors = [] as User[];

  inspectorList: User[];

  value: string;
  values: string[];

  constructor(private userService:UserService) {}

  ngOnInit(): void {
    this.userService.getInspectors().subscribe(il => {
      this.inspectorList = il;
    })
    this.values = this.toStringList(this.inspectors);
  }

  toStringList(il: User[]): string[] {
    const names = [] as string[];
    il.forEach(i => { names.push(_.cloneDeep(i.name))});
    return names;
  }

  toString(user: User): string {
    return user.name;
  }

  add() {
    const inspector = this.find(this.value);
    if (!this.inspectors.some( i => i.user === inspector.user)) {
      this.inspectors.push(inspector);
      this.values.push(_.cloneDeep(inspector.name));
    }
  }

  find(username: string): User {
    return this.inspectorList.find((u) => username === u.user);
  }

  onRemove(name: string) {
    const index = this.inspectors.findIndex((u) => name === u.name);
    this.inspectors.splice(index, 1);
  }
}
